import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { createForm } from 'rc-form';
// import createDOMForm from 'rc-form/lib/createDOMForm';

export const FIELD_META_PROP = 'data-__meta';
export const FIELD_DATA_PROP = 'data-__field';

export default class Form extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  };

  render() {
    const { ...rest } = this.props;
    return <form onSubmit={(e) => e.preventDefault()} {...rest} />;
  }
}

class FormItem extends React.PureComponent {
  getControl(children) {
    const childrenArray = React.Children.toArray(children);
    return childrenArray.find((child) => {
      return FIELD_META_PROP in child.props || 'form' in child.props;
    });
  }

  getHelpMessage(control) {
    if (control) {
      const errors =
        control.props[FIELD_DATA_PROP] && control.props[FIELD_DATA_PROP].errors;
      if (errors && errors.length) {
        return errors[0].message;
      }
    }
  }

  render() {
    const { children } = this.props;
    const control = this.getControl(children);
    const error = this.getHelpMessage(control);
    return React.cloneElement(control, {
      hasError: !!error,
      helpText: error,
    });
  }
}

const FieldArray = ({ children, form, name }) => {
  const uuid = useRef(0);
  const keyName = `${name}_keys`;

  const remove = (k) => {
    // can use data-binding to get
    let keys = form.getFieldValue(keyName);
    keys = keys.filter((key) => {
      return key !== k;
    });
    // can use data-binding to set
    form.setFieldsValue({
      [keyName]: keys,
    });
  };

  const add = (defaultValues) => {
    uuid.current += 1;
    // can use data-binding to get
    let keys = form.getFieldValue(keyName);
    keys = keys.concat(uuid.current);
    form.setFieldsValue({
      [keyName]: keys,
    });
    if (defaultValues) {
      Object.keys(defaultValues).forEach((key) => {
        form.getFieldDecorator(`${name}[${uuid.current}].${key}`, {
          initialValue: defaultValues[key],
        });
      });
    }
  };

  form.getFieldProps(keyName, {
    initialValue: [0],
  });

  const keys = form.getFieldValue(keyName);

  return children({
    add,
    remove,
    keys,
  });
};

Form.FormItem = FormItem;

Form.FieldArray = FieldArray;

Form.create = function (options = {}) {
  return createForm({
    fieldNameProp: 'id',
    ...options,
    fieldMetaProp: FIELD_META_PROP,
    fieldDataProp: FIELD_DATA_PROP,
  });
};
